document.addEventListener("DOMContentLoaded", function () {
	const login = document.getElementById("customer-login");
	const forgotPassword = document.getElementById("forgot-password");

	const recover = document.getElementById("customer-recover");
	const cancel = document.getElementById("recover-cancel");

	if (login && recover) {
		if (window.location.hash === "#recover") {
			login.style.display = "none";
			recover.style.display = "flex";
		}

		if (forgotPassword) {
			forgotPassword.addEventListener("click", function () {
				login.style.display = "none";
				recover.style.display = "flex";
			});
		}
		if (cancel) {
			cancel.addEventListener("click", function () {
				recover.style.display = "none";
				login.style.display = "flex";
			});
		}
	}
});
